import React, { useEffect, useState } from 'react';

export const Occupations = ({
  togglePanel,
  formData,
  onFormDataChange,
  onNext,
  fetchData,
  loading,
  error
}: any) => {

  const [occupations, setOccupations] = useState<{ id: number; name: string }[]>([]);
  const excludedIds = [9, 16];

  useEffect(() => {
    const loadOccupations = async () => {
      const query = new URLSearchParams({ excluded_ids: excludedIds.join(',') }).toString();
      const data = await fetchData(`/api/v1/user_occupations?${query}`);
      if (data) {
        setOccupations(data);
      }
    };

    loadOccupations();

  }, []);

  const handleCheckboxChange = (id: number) => {
    const updated = formData.occupations.includes(id)
      ? formData.occupations.filter((occId: number) => occId !== id)
      : [...formData.occupations, id];
    onFormDataChange('occupations', updated);
  };

  return (
    <div className="p-searchPanel">

      <div className="p-searchPanel__header">
        <div className="p-searchPanel__title">検索条件（職種）1/3</div>
        <button
          className="p-searchPanel__closeButton"
          onClick={togglePanel}
        ></button>
      </div>

      {loading && <div>ロード中...</div>}
      {error && <div style={{ color: "red" }}>{error}</div>}

      <div className="p-searchPanel__section">
        <div className="p-searchPanel__section__items">
          {occupations.map((occupation) => (
            <div key={occupation.id}>
              <input
                type="checkbox"
                id={`occupation_${occupation.id}`}
                className="c-formItem__checkbox"
                checked={formData.occupations.includes(occupation.id)}
                onChange={() => handleCheckboxChange(occupation.id)}
              />
              <label
                htmlFor={`occupation_${occupation.id}`}
                className="c-formItem__label -hasChedkbox"
              >
                {occupation.name}
              </label>
            </div>
          ))}
        </div>
      </div>
      <div className="p-searchPanel__buttons">
        <button
          className="p-searchPanel__actionButton p-searchPanel__actionButton--next"
          onClick={onNext}
        >次へ</button>
      </div>
    </div>
  );
};
